import { CalendarX, DoorOpen, HandHeart, PhoneOff } from "lucide-react";
import { PROBLEMS } from "../constants";
import { Reveal } from "./Reveal";
import { useTilt } from "../hooks/useTilt";

const ICONS = { CalendarX, DoorOpen, HandHeart, PhoneOff };

const ProblemCard = ({ p, index }) => {
    const tilt = useTilt(6);
    const Icon = ICONS[p.icon];
    return (
        <Reveal delay={index * 0.1}>
            <div
                ref={tilt.ref}
                onMouseMove={tilt.onMouseMove}
                onMouseLeave={tilt.onMouseLeave}
                className="tilt-card h-full rounded-3xl border border-slate-100 bg-white p-6 sm:p-8 shadow-[0_10px_40px_-16px_rgba(15,23,42,0.10)] hover:shadow-[0_24px_60px_-18px_rgba(11,92,245,0.22)] hover:border-[#0B5CF5]/25"
                data-testid={`problem-card-${index}`}
            >
                <div className="w-12 h-12 rounded-2xl bg-[#F4F8FF] flex items-center justify-center mb-5">
                    <Icon size={22} className="text-[#0B5CF5]" />
                </div>
                <h3 className="text-lg font-bold text-slate-900 mb-2 tracking-tight">{p.title}</h3>
                <p className="text-sm text-slate-600 leading-relaxed">{p.desc}</p>
            </div>
        </Reveal>
    );
};

const Problem = () => (
    <section id="about" className="py-16 sm:py-24 lg:py-32 bg-white" data-testid="problem-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
            <Reveal>
                <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#0B5CF5] mb-4">The everyday struggle</p>
            </Reveal>
            <Reveal delay={0.08}>
                <h2
                    className="font-display font-medium text-slate-900 text-2xl sm:text-3xl lg:text-4xl tracking-tight max-w-2xl leading-[1.1]"
                    data-testid="problem-section-title"
                >
                    Need a helping hand? <span className="italic text-[#0B5CF5]">We've got a better idea.</span>
                </h2>
            </Reveal>
            <Reveal delay={0.16}>
                <p className="mt-5 text-base sm:text-lg text-slate-600 max-w-2xl leading-relaxed">
                    Everyday chores shouldn't come with stress, last-minute cancellations or uncertain phone
                    calls. These are the moments Sevano is being built for.
                </p>
            </Reveal>

            <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 tilt-scene">
                {PROBLEMS.map((p, i) => (
                    <ProblemCard key={p.title} p={p} index={i} />
                ))}
            </div>
        </div>
    </section>
);

export default Problem;
